module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAStJREFUOBGtU7tqAlEQPROCYGOvgn6AkI+wEPIfWoSk8kNSRSzMfwS22I8IprRwQe1tBAtv5twHu6NZYogDu3dn5syZx84VnInb7QZwbqzmkT696C70zCDyLu32V7T5Q5LinGtgu31V0JMS3CW7OUVO6puj05mKyJE+TxCDP1QfmoB6JVeSR5KETMx8fTBph75a/ZDY86cpe78H8hxYrwkG+n0N0eJaraDzzXZEHu79wKo9M3ixAA6HErxcAqsVMJmUJCFmzBY47VKYuRqcPLTRZ2VEgvSrgiuVbYF1vl4Y4k/gK20kKAyWA6uTS19BgszgOe1m05i8Qht9VrJ//8awiZvNmxI/W/JftZl0uy+3WWV/MXS3NefMb1hdcm4fMfEeEOYrqOL/ep2/AWIvfXfMFvrKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-icon-acne-3@2x.png
// module id = gOKs
// module chunks = 1